import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedOregonSubjectArea = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add a subject area"
    okText="ADD A SUBJECT AREA"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a subject area:"
      queryVariables={{ typeId: FILTER_TYPE.SUBJECT_AREA.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Subject area is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedOregonSubjectArea.Item = Item;

export default RelatedOregonSubjectArea;
